import React, { FC, useState } from 'react'
import TabTile from 'tabs/data/components/TabTile'
import { Column } from 'tabs/data/api/generated'
import { Highlighted } from 'tabs/data/components/Highlighted'
import { Option } from 'helpers/selects'
import { SchemaOutlined } from '@mui/icons-material'
import { RelationshipForm } from '../RelationshipForm'
import { RelationshipsRequest, RelationshipType, TableRelationshipFilterDirection } from '../relationships.types'

type DatasetRelationshipsTileProps = {
  datasetId: string
  relationId: string
  source: string
  destination: string
  highlight: string
  sourceColumn: string
  targetColumn: string
  type: RelationshipType
  direction: TableRelationshipFilterDirection
  tableOptions: Option[]
  columns: Map<string, Column[]>
  sourceTitle: string
  destinationTitle: string
  onDelete: () => Promise<void>
  onChange: (relationId: string, relationRequest: RelationshipsRequest) => void
}

const foo = (direction: string): string => {
  switch (direction) {
    case TableRelationshipFilterDirection.CROSS:
      return '⭤'
    case TableRelationshipFilterDirection.SINGLE:
      return '⭠'
    default:
      return '-'
  }
}

export const DatasetRelationshipsTile: FC<DatasetRelationshipsTileProps> = ({
  source,
  relationId,
  destination,
  highlight,
  sourceColumn,
  targetColumn,
  type,
  direction,
  tableOptions,
  onChange,
  sourceTitle,
  destinationTitle,
  columns,
  onDelete,
}) => {
  const [expandedTable, setExpandedTable] = useState(false)

  const title = `${sourceTitle}  ${foo(direction)}  ${destinationTitle}`
  const description = `[${sourceColumn}]  ${foo(direction)}  [${targetColumn}]`

  const handleToggleExpand = () => {
    setExpandedTable(!expandedTable)
  }

  return (
    <TabTile
      expanded={expandedTable}
      tab={{
        name: <Highlighted text={title} highlight={highlight} />,
        icon: <SchemaOutlined fill={'var(--bs-gray-600)!important'} />,
        description: <Highlighted text={description} highlight={highlight} />,
      }}
      onChange={handleToggleExpand}>
      {expandedTable && (
        <RelationshipForm
          type={type}
          sourceTable={source}
          destinationTable={destination}
          direction={direction}
          sourceColumn={sourceColumn}
          targetColumn={targetColumn}
          cancelButtonLabel="Reset"
          submitButtonLabel="Save"
          options={tableOptions}
          joinedTables={[]}
          synonyms={[]}
          columns={columns}
          onSubmit={async (request) => onChange(relationId, request)}
          onDelete={onDelete}
        />
      )}
    </TabTile>
  )
}
